import { render } from "./BlogPersonalizedGiftsView.vue?vue&type=template&id=e1c64c46"
import script from "./BlogPersonalizedGiftsView.vue?vue&type=script&lang=js"
export * from "./BlogPersonalizedGiftsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__